import { Injectable, signal } from '@angular/core';

export interface OverlayRef {
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private openOverlayRefs = signal<OverlayRef[]>([]);

  public open(): OverlayRef {
    const ref: OverlayRef = {
      id: generateGuid(),
    };

    const openOverlayRefs = [...this.openOverlayRefs(), ref];
    this.openOverlayRefs.set(openOverlayRefs);
    this.hideRootScrollbarIfOverlaysAreVisible(openOverlayRefs);

    return ref;
  }

  public close(overlayRef: OverlayRef): void {
    const openOverlayRefs = this.openOverlayRefs().filter((ref) => ref.id !== overlayRef.id);
    this.openOverlayRefs.set(openOverlayRefs);
    this.hideRootScrollbarIfOverlaysAreVisible(openOverlayRefs);
  }

  private hideRootScrollbarIfOverlaysAreVisible(openOverlayRefs: OverlayRef[]) {
    if (openOverlayRefs.length > 0) {
      window.document.documentElement.style.setProperty('overflow', 'hidden');
    } else {
      window.document.documentElement.style.removeProperty('overflow');
    }
  }
}

const generateGuid = () => `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;

const s4 = () =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
